import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';

export class SectionTitle extends Component {
    renderIcon = () => {
        const { icon } = this.props;

        if (!icon) return null;

        if (React.isValidElement(icon)) {
            return icon;
        }

        if (typeof icon === 'string') {
            return (
                <Box
                    component="img"
                    src={icon}
                    alt=""
                    sx={{ width: 24, height: 24, objectFit: 'contain' }}
                />
            );
        }

        return null;
    };

    render() {
        const { label, style } = this.props;

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    ...style,
                }}
            >
                {this.renderIcon()}
                <Typography
                    sx={{
                        color: '#353535',
                        fontWeight: 'bold',
                        fontSize: 16,
                    }}
                >
                    {label}
                </Typography>
            </Box>
        );
    }
}

export default SectionTitle;